<template>
  <div>
    <b-card no-body class="mb-0">
      <div class="m-2 mt-3">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>Afficher</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="pageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>entrées</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filterInput" type="search"
                  placeholder="Saisissez votre recherche" @keyup="applyFilter" />
                <b-input-group-append>
                  <b-button @click="applyFilterEnter">
                    Rechercher
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
          <b-col cols="12" md="6" />
          <!-- Filter On -->
          <b-col cols="12" md="6">
            <b-form-group v-slot="{ ariaDescribedby }" v-model="sortDirection"
              description="Laissez tout décoché pour filtrer sur toutes les données" class="mt-0">
              <b-form-checkbox-group v-model="filterOn" :aria-describedby="ariaDescribedby" class="mt-1 mb-0">
                <b-form-checkbox class="mb-1" value="date">
                  Date
                </b-form-checkbox>
                <b-form-checkbox class="mb-1" value="ref">
                  Référence
                </b-form-checkbox>
                <b-form-checkbox class="mb-1" value="client">
                  Client
                </b-form-checkbox>
                <b-form-checkbox class="mb-1" value="commercial">
                  Commercial
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Tableau -->
        <b-row>
          <b-col cols="12">
            <b-table id="datatables" class="mt-4 mb-4" :items="Commandes" :fields="fields" stacked="md"
              :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" striped small
              @filtered="onFiltered" @row-clicked="selectedCol">
              <template #cell(date)="data">
                {{ moment(data.item.date).format('DD/MM/YYYY HH:mm') }}
              </template>
              <template #cell(totalht)="data">
                <span>{{ parseFloat(data.item.totalht).toFixed(2) }} € HT</span><br />
                <span style="font-size: 11px;">{{ parseFloat(data.item.totalttc).toFixed(2) }} € TTC</span>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <span class="d-inline-flex align-items-center" @click.stop>
                  <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    :to="{ name: 'invoice', params: { id: data.item.key } }" variant="success"
                    class="btn-icon rounded-circle mr-50">
                    <feather-icon icon="DownloadIcon" />
                  </b-button>
                  <b-button
                    v-if="data.item.statut === 'En cours'"
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    v-b-modal.modal-delete-commande
                    variant="outline-danger"
                    class="btn-icon rounded-circle"
                    @click="commandeToDelete = data.item"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </span>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" />
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal
      id="modal-delete-commande"
      title="Supprimer la commande"
      ok-title="Supprimer"
      ok-variant="danger"
      cancel-title="Annuler"
      @ok="confirmDeleteCommande"
    >
      <p v-if="commandeToDelete">
        Confirmer la suppression de la commande
        <strong>{{ commandeToDelete.ref }}</strong>
        ({{ commandeToDelete.client }}) ?
        Cette action est irréversible.
      </p>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BTable,
  BLink,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'
import moment from 'moment'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BTable,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BModal,
    vSelect,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  data() {
    return {
      fields: [
        { key: 'date', label: 'Date', sortable: true },
        { key: 'ref', label: 'Référence', sortable: true },
        { key: 'client', label: 'Client', sortable: true },
        { key: 'commercial', label: 'Commercial', sortable: true },
        { key: 'statut', label: 'Statut', sortable: true },
        { key: 'totalht', label: 'Total HT', sortable: false },
        { key: 'actions', label: '', thStyle: { width: '96px' } },
      ],
      Commandes: [],
      isLoading: true,
      drawer: true,
      perPage: 50,
      currentPage: 1,
      totalRows: 1,
      currentPage: 1,
      filterInput: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      outlined: true,
      filterOn: [],
      sortBy: 'date',
      sortDirection: 'desc',
      sortDesc: true,
      moment: moment,
      commandeToDelete: null,
      setting: JSON.parse(localStorage.setting),
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url') + '/' + localStorage.getItem('database')),
      role: localStorage.getItem('role'),
    }
  },
  computed: {
    /**
      * Total no. of records
      */
    rows() {
      return this.items.length
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {},
  created() {

    // Création du sélecteur sur les commandes
    if (this.setting.filtre_commandes_par_commerciaux == false || this.setting.filtre_commandes_par_commerciaux == 'false' || this.role.includes('admin' + localStorage.getItem('database')) || this.role.includes('manager' + localStorage.getItem('database'))) {
      this.localDB.find({ selector: { type: 'commandes' } }, this.setCommandes)
    }
    else {
      this.localDB.find({ selector: { type: 'commandes', commercial: localStorage.getItem('user') } }, this.setCommandes)
    }

  },
  mounted() { },
  customButtons: {
    default: true,
  },
  methods: {
    moment() {
      return moment();
    },
    setCommandes(err, doc) {
      if (err) {
        console.log('err', err)
      }
      console.log('doc', doc)
      for (let i = 0; i < doc.docs.length; i++) {
        this.Commandes.push({
          key: doc.docs[i]._id,
          ref: doc.docs[i].client.idclient,
          client: doc.docs[i].client.nom,
          date: doc.docs[i].datecommande,
          statut: doc.docs[i].statut,
          commercial: doc.docs[i].commercial,
          totalht: doc.docs[i].totalmontant,
          totalttc: doc.docs[i].totalmontantttc,
        })
      }
      this.totalRows = this.Commandes.length
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    applyFilter() {
      if (this.filterInput.length >= 3) {
        this.filter = this.filterInput
      } else {
        this.filter = ''
      }
    },
    applyFilterEnter() {
      this.filter = this.filterInput
    },
    selectedCol(item) {
      this.$router.push({ name: 'viewcommande', params: { id: item.key } })
    },
    async confirmDeleteCommande(bvModalEvt) {
      bvModalEvt.preventDefault()
      if (!this.commandeToDelete) {
        this.$nextTick(() => this.$bvModal.hide('modal-delete-commande'))
        return
      }
      const { key } = this.commandeToDelete
      try {
        const doc = await this.localDB.get(key)
        if (doc.statut !== 'En cours') {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Suppression impossible',
              icon: 'CoffeeIcon',
              variant: 'warning',
              text: 'Seules les commandes au statut « En cours » peuvent être supprimées.',
            },
          })
          this.$nextTick(() => this.$bvModal.hide('modal-delete-commande'))
          return
        }
        await this.localDB.remove(doc)
        const idx = this.Commandes.findIndex(c => c.key === key)
        if (idx !== -1) {
          this.Commandes.splice(idx, 1)
        }
        this.totalRows = this.Commandes.length
        this.commandeToDelete = null
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Commande supprimée',
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'La commande a été supprimée en local. Synchronisation en cours…',
          },
        })

        this.localDB.sync(this.remoteDB)
          .on('complete', () => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Synchronisation terminée',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'La suppression a été synchronisée avec le serveur.',
              },
            })
          })
          .on('error', () => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Problème de synchronisation',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: 'La commande est supprimée en local mais la synchronisation a échoué. Réessayez plus tard.',
              },
            })
          })
      } catch (err) {
        console.error(err)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erreur',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: err.message || 'Impossible de supprimer la commande.',
          },
        })
      } finally {
        this.$nextTick(() => this.$bvModal.hide('modal-delete-commande'))
      }
    },
  },
}
</script>

<style>
.btn-primary {
  margin-right: 12px;
}

.per-page-selector {
  width: 90px;
}

.btNopadding button {
  padding: 0;
}

@media (max-width: 767.98px) {
  .table.b-table.b-table-stacked-md>tbody>tr>[data-label]::before {
    text-align: left;
  }
}

table tbody tr {
  height: 60px;
  cursor: pointer;
}
</style>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
